import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, firstValueFrom, Observable, filter } from 'rxjs';
import { BasicAuth } from '../interfaces/basic-auth.interface';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GenericLoginService {

  private readonly genericLoginSubject = new BehaviorSubject<boolean | null>(null);
  private readonly genericLogin$ = this.genericLoginSubject.asObservable();
  constructor(private readonly httpClient: HttpClient) {
    const isAuthenticated = localStorage.getItem('isBasicAuthSuccess');
    if (isAuthenticated === 'true') {
      this.genericLoginSubject.next(true);
    }
  }

  getGenericLoginObservable(): Observable<boolean | null> {
    return this.genericLogin$;
  }

  openGenericLoginModal(): Promise<boolean> {
    this.genericLoginSubject.next(null);
    this.genericLoginSubject.next(false);
    return firstValueFrom(
      this.genericLogin$.pipe(filter((result): result is boolean => result !== null))
    );
  }

  triggerLogin() {
    localStorage.setItem('isBasicAuthSuccess', 'true');
    this.genericLoginSubject.next(true);
  }

  declineLogin() {
    this.genericLoginSubject.next(false);
  }

  /**
   * @description Temporary login for dev and int portals
   * @param username
   * @param password
   * @returns Observable
   */
  public basicAuthLogin(username: string, password: string): Observable<BasicAuth> {
    const url = environment.proxyEndpoint + '/auth/checkUserAccess'
    return this.httpClient.post<BasicAuth>(url,
      {"userName": username,"userPassword" :password}
    );
  }

  private updateGenericLoginState(value: boolean | null): void {
    this.genericLoginSubject.next(value);
  }

}
